<template>
  <div class="vx-card p-6">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
      MÜŞTERİ RAPOR YÖNETİMİ
    </div>
    <form class="vx-row" @submit.prevent="customerReport()">
      <div style="width: 100%;">
        <div class="vx-row mt-3">
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>Ülke</b></label>
            <v-select name="countrySelection" v-model="country" v-validate="'required'" placeholder="Ülke" :options="countries" label="value" class="w-full" :reduce="(countries) => countries.id" @input="getCities()">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>İl</b></label>
            <v-select name="citySelection" v-model="city" placeholder="İl" :options="cities" label="value" class="w-full" :reduce="(cities) => cities.id" @input="getCounties()">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>İlçe</b></label>
            <v-select name="citySelection" v-model="county" placeholder="İlçe" :options="counties" label="value" class="w-full" :reduce="(counties) => counties.id" @input="customerReport()">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>Etiket</b></label>
            <v-select name="tagsSelection" v-model="selectedTag" placeholder="Etiket" :options="tags" label="value" class="w-full" :reduce="(tags) => tags.id" @input="customerReport()">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>Başlangıç</b></label>
            <vs-input type="date" class="w-full" v-model="startDate"></vs-input>
          </div>
          <div class="vx-col md:w-1/4">
            <label class="text-sm"><b>Bitiş</b></label>
            <vs-input type="date" class="w-full" v-model="dueDate" @change="customerReport()"></vs-input>
          </div>
          <div class="vx-col md:w-1/4 mt-5">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 mt-3">
                <b><vs-checkbox v-model="isOutofTR" @input="customerReport()">TR Dışı</vs-checkbox></b>
              </div>
              <div class="vx-col md:w-1/2 mt-3">
                <div style="cursor: pointer; width: 100px;" class="px-4 py-1 flex items-center">
                  <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                  <JsonExcel :data="customers" class><b>İndir</b></JsonExcel>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/4 mt-5">
            <div class="flex flex-wrap items-center ml-2 mt-3">
              <vs-button size="small" type="border" color="warning">Görüntüle</vs-button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <vs-table search noDataText="Rapor Bulunamadı!" :data="customers" :pagination="true" :maxItems="7" class="w-full">
      <template slot="thead">
        <vs-th style="width: 30px;">Müşteri</vs-th>
        <vs-th style="width: 30px;">MüşteriId</vs-th>
        <vs-th style="width: 30px;">Mail</vs-th>
        <vs-th style="width: 30px;">Telefon</vs-th>
        <vs-th style="width: 30px;">Ülke</vs-th>
        <vs-th style="width: 30px;">İl</vs-th>
        <vs-th style="width: 30px;">İlçe</vs-th>
        <vs-th style="width: 30px;">Etiket</vs-th>
        <vs-th style="width: 30px;">Personel</vs-th>
        <vs-th style="width: 30px;">Tarih</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(tr, i) in data" :key="i">
          <vs-td>{{ tr.customer }}</vs-td>
          <vs-td>{{ tr.id }}</vs-td>
          <vs-td>{{ tr.email }}</vs-td>
          <vs-td>{{ tr.phone }}</vs-td>
          <vs-td>{{ tr.countryName }}</vs-td>
          <vs-td>{{ tr.city }}</vs-td>
          <vs-td>{{ tr.countyName }}</vs-td>
          <vs-td>{{ tr.tags }}</vs-td>
          <vs-td>{{ tr.createdBy }}</vs-td>
          <vs-td>{{ tr.createdDate.substr(0, 10) }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    vSelect,
    JsonExcel,
  },
  data() {
    return {
      cities: [],
      countries: [],
      counties: [],
      customers: [],
      country: 52,
      city: 0,
      county: 0,
      tags: [],
      selectedTag: null,
      startDate: undefined,
      dueDate: undefined,
      isOutofTR: null,
    };
  },
  created() {
    Promise.all([this.getCountries(), this.getCities(), this.getTags(), this.getCounties()]);
  },
  methods: {
    customerReport: async function () {
      let CustomerReportSearchCriteria = {
        country: this.country,
        city: this.city,
        tagId: this.selectedTag,
        startDate: this.startDate,
        dueDate: this.dueDate,
        isOutofTR: this.isOutofTR,
        county: this.county,
      };

      if (this.country == 52 && this.city == 0 && this.selectedTag == undefined && this.startDate == undefined && this.dueDate == undefined) {
        this.$vs.notify({
          title: "Hata",
          text: "Lütfen il seçiniz!",
          color: "danger",
        });
      }
      this.customers = await repository.postEntity("Reports/GetCustomerReport", CustomerReportSearchCriteria).then((r) => r.list);
      console.log("customers", this.customers);
    },

    getCountries: async function () {
      await repository.getAll("General/getCountries").then((r) => (this.countries = r.list));
    },

    getCities: async function () {
      this.city = 0;
      this.county = 0;
      await repository.getAll("General/getCities").then((r) => {
        this.cities = r.list.filter((x) => x.countryId == this.country);
      });
    },

    getCounties: async function () {
      this.county = 0;
      await repository.getAll("General/getCounties").then((r) => {
        this.counties = r.list.filter((x) => x.cityId == this.city);
      });
    },
    getTags: async function () {
      this.tags = await repository.getAll("General/getCustomerTags").then((r) => r.list);
    },
  },
};
</script>
